<div class="card-container d-flex flex-column justify-content-center align-items-start">
  <div class="card-inner-container d-flex flex-column justify-content-center align-items-center">
    <div class="w-100 h-100 d-flex flex-row justify-content-start align-items-center">
      <div [style.background-image]="'url(\'' + candidate.photo.path + '\')'" class="card-image"></div>
      <div class="card-text-container d-flex flex-column justify-content-end">
        <div>{{candidate.firstName}}</div>
        <div>{{candidate.lastName}}</div>
        <div>{{candidate.candidateType === 1 ? 'Candidat Senatul Universității' : 'Candidat Consiliul Facultății'}}</div>
      </div>
    </div>
    <div class="buttons w-100 d-flex justify-content-between align-content-center">
      <app-button label="Da" [disabled]="isDisabled(voteTypes.DA)"
                  [type]="isDisabled(voteTypes.DA) ? 'disabled' : (isSelected(voteTypes.DA) ? 'light-filled' : 'blue-filled')"
                  textType="big" (action)="vote(voteTypes.DA)"></app-button>
      <app-button label="Nu" [type]="isSelected(voteTypes.NU) ? 'light-filled' : 'blue-filled'"
                  textType="big" (action)="vote(voteTypes.NU)"></app-button>
      <app-button label="Mă Abțin" [type]="isSelected(voteTypes.MA_ABTIN) ? 'light-filled' : 'blue-filled'"
                  textType="big" (action)="vote(voteTypes.MA_ABTIN)"></app-button>
    </div>
  </div>
</div>
